"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnnouncementsLocale = getAnnouncementsLocale;

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function getAnnouncementsLocale(locale) {
  switch (locale) {
    case 'de-DE':
      return 'de';

    case 'es-ES':
      return 'es';

    case 'fr-FR':
      return 'fr';

    case 'it-IT':
      return 'it';

    case 'ja-JP':
      return 'ja';

    case 'ko-KR':
      return 'ko';

    case 'pt-BR':
      return 'pt';

    case 'zh-CN':
      return 'zh-Hans';

    case 'zh-TW':
      return 'zh-Hant';

    default:
      return 'en';
  }
}